const Arrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16602 10H17.4993"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.38876 5.11136L2.64142 9.8587C2.56332 9.93681 2.56332 10.0634 2.64142 10.1415L7.38876 14.8889"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Arrow;
